// you can import modules from the theme lib or even from
// NPM packages if they support it…
import 'owl.carousel';

// Some convenient tools to get you started…
// import ReplaceObfuscatedEmailAddresses from "./components/ReplaceObfuscatedEmailAddresses";
import AnimateOnPageLinks from "./components/AnimateOnPageLinks";
import FeaturedProductSlider from "./components/FeaturedProductsSlider";
import Claims from "./components/Claims";
import Dots from "./components/Dots";
import SelectOptions from "./components/SelectOptions";
import AccordionToggle from './components/AccordionToggle';
import ImageSwap from './components/ImageSwap';
import VideoViewport from './components/VideoViewport';
import SidebarSlide from './components/SidebarSlide';
import LoadMorePosts from './components/LoadMorePosts';

// Initialise our components on jQuery.ready…
jQuery(function ($) {
    // ReplaceObfuscatedEmailAddresses.init();
    AnimateOnPageLinks.init();
    FeaturedProductSlider.init();
    Claims.init();
    Dots.init();
    SelectOptions.init();
    AccordionToggle.init();
    ImageSwap.init();
    VideoViewport.init();
    SidebarSlide.init();
    LoadMorePosts.init();
});